import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f3145332&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3145332",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3145332')) {
      api.createRecord('f3145332', component.options)
    } else {
      api.reload('f3145332', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f3145332&scoped=true&", function () {
      api.rerender('f3145332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ze5sY6jLHenO/JS/comp/SearchFilterTokens.vue"
export default component.exports